
const FounderStorySection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <img
              src="https://static.readdy.ai/image/2a3205e7e8ef8b3d476f9ddb9e8c5218/a6fd3f2eba45bc86ac56984a44040a16.jpeg"
              alt="Legacy Business Acquisitions Logo"
              className="rounded-lg shadow-lg w-full h-auto object-contain"
            />
          </div>
          
          <div>
            <h2 className="font-playfair text-4xl font-bold text-navy mb-6">
              A Note From the Founder
            </h2>
            <div className="space-y-4 text-gray-600 leading-relaxed">
              <p>
                After nearly three decades in risk and wealth management, I've watched business owners wrestle with one of the most important decisions of their lives: how to exit their business without losing what made it special.


              </p>
              <p>
                Over the years I've seen that a business is more than its financial statements. The people, the customer relationships, the reputation you've built in your community, those matter just as much as the bottom line.


              </p>
              <p>
                I founded Legacy Business Acquisitions to be a different kind of buyer. One that respects the work it took to build your business, and one that balances fair numbers with genuine stewardship.


              </p>
              <p>
                When you work with Legacy, you're not just getting a buyer. You're getting a steady hand that understands the weight of what you're entrusting to us and the responsibility that comes with it.
              </p>
            </div>
            <div className="mt-6">
              <p className="font-['Brush_Script_MT',_cursive] text-3xl text-navy">Brian</p>
            </div>
            <div className="mt-8 p-6 bg-soft-gray rounded-lg">
              <h3 className="font-semibold text-navy mb-2">Brian's Background</h3>
              <ul className="text-sm text-gray-600 space-y-1">
                <li>• 30 years in wealth and risk management</li>
                <li>• Extensive experience reviewing businesses, financials, and deal structures



</li>
                <li>• Deep understanding of business valuations and acquisition financing</li>
                <li>• North Carolina roots; national reach</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FounderStorySection;
